export const FETCH_FAILED = 'fetch_failed';
export const PROVISIONING_FAILED = 'provisioning_failed';
export const INVALID_QUOTE = 'invalid_quote';
export const UPDATE_BILLING_INFO_FAILED = 'update_billing_info_failed';
